module.exports = __webpack_public_path__ + "media/customizations/valenciatrails/logo-new-a59cf5f9a782bce325b5bb238015fbf8.png";